export default {
  display: {
    class: [
      // Display
      'inline',

      // Spacing
      'p-0',

      // Shape
      'rounded-md',

      // Colors
      'text-neutral-700 dark:text-white/80',

      // States
      'hover:bg-neutral-100 hover:text-neutral-700 dark:hover:bg-neutral-700/80 dark:hover:text-white/80',

      // Transitions
      'transition',
      'duration-200',

      // Misc
      'cursor-pointer'
    ]
  }
}
